import {
  IPerformanceQueryParameters,
  IChartResult,
  ICustomerActivity,
  IPerformanceOverview,
  IPerformancePagination
} from '@/models/performance';
import APIService from '../api';

export default class PerformanceOverview extends APIService {
  getOverview() {
    return this.get<IPerformanceOverview>('/v2/admin/business/overview');
  }

  getNewOverview() {
    return this.get<IPerformanceOverview>('/v3/admin/business/overview');
  }

  getCustomerGrowth(filters: IPerformanceQueryParameters = {}) {
    return this.get<IChartResult>('/v2/admin/customer/growth', {
      params: filters
    });
  }

  getCoinsReports(filters: IPerformanceQueryParameters = {}) {
    return this.get<IChartResult>('/v2/admin/customer/coins', {
      params: filters
    });
  }

  getYourCampaigns(filters: IPerformanceQueryParameters = {}) {
    return this.get<IChartResult>(`/v2/admin/activity/business/timeline`, {
      params: filters
    });
  }

  getCustomerDetail(customerId: string) {
    return this.get(`/v2/admin/customer/${customerId}`);
  }

  getCustomerActivities(
    resource: string,
    filters: Omit<IPerformanceQueryParameters, 'shortcut'> = {}
  ) {
    return this.get<IPerformancePagination<ICustomerActivity>>(resource, {
      params: filters
    });
  }
}
